module.exports = __webpack_public_path__ + "static/media/SMotorS.823b3ff5.jpeg";